import { atomWithStorage } from "jotai/utils";

export const selectedOrganizationIdAtom = atomWithStorage<string>(
  "selected-organization-id",
  "P",
);
